import { getConsentCategoryIds } from "./getConsentCategoryIds";
import { asosGlobalNamespace } from "@template/constants";
import { ONETRUST_CONSENT_CHANGED } from "./constants";

export const emitConsentChangedEvent = () => {
  const consent = getConsentCategoryIds();
  window[asosGlobalNamespace].eventBus.emit(ONETRUST_CONSENT_CHANGED, consent);
};
